import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, Typography, Avatar } from '@material-ui/core';
import gradients from 'src/utils/gradients';
import HelpIcon from '@material-ui/icons/HelpOutline';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    height: 120,
    backgroundImage: theme.palette.common.white,
    '&.background-gradient-blue': {
      background: gradients.blue,
      '& .MuiSvgIcon-root': {
        color: theme.palette.colorPalette[1]
      }
    },
    '&.background-gradient-green': {
      background: gradients.green,
      '& .MuiSvgIcon-root': {
        color: theme.palette.colorPalette[2]
      }
    },
    '&.light-blue': {
      '& .MuiAvatar-root': {
        background: theme.palette.colorPalette[2]
      },
      '& .MuiTypography-h2': {
        color: theme.palette.colorPalette[2]
      },
      '& .MuiTypography-overline': {
        color: '#888a91'
      }
    }
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  label: {
    marginLeft: theme.spacing(1)
  },
  headline: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.common.white,
    fontSize: '16px',
    fontWeight: 'bold'
  },
  amount: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '42px',
    lineHeight: '58px',
    fontWeight: 'bold',
    color: theme.palette.common.white
  },
  avatar: {
    background: theme.palette.common.white,
    height: 48,
    width: 48,
    '& .MuiSvgIcon-root': {
      fontSize: '32px'
    },
    marginLeft: "3px"
  },
  smallIcon: {
    fontSize: 16,
    marginLeft: 2
  },
  headlineWrapper: {
    display: 'flex',
    alignItems: 'center'
  }
}));

function OverviewBox({
  headline, amount, icon, className, ...rest
}) {
  const classes = useStyles();

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <Typography component="h3" gutterBottom variant="overline" className={classes.headline}>
        <div className={classes.headlineWrapper}>
          <div>{headline}</div>
          {rest.title && <HelpIcon className={classes.smallIcon} />}
        </div>
      </Typography>
      <div className={classes.details}>
        <Typography className={classes.amount} variant="h2">
          {amount}
        </Typography>
        <Avatar className={classes.avatar}>{icon}</Avatar>
      </div>
    </Card>
  );
}

OverviewBox.propTypes = {
  className: PropTypes.string
};

export default OverviewBox;
